module.exports = __webpack_public_path__ + "img/at-work.4e7e24fa.webp";